import { useRef, useState } from "react";
import { Camera, Loader2, User } from "lucide-react";
import { toast } from "sonner";
import { fileToCompressedDataUrl } from "@/lib/photo";

export function PhotoUpload({ value, onChange, testid = "photo-upload" }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const dataUrl = await fileToCompressedDataUrl(file);
      onChange(dataUrl);
    } catch (err) {
      toast.error(err.message || "Could not load image.");
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div className="flex items-center gap-4">
      <div className="relative w-20 h-20 rounded-full overflow-hidden border border-zinc-700 bg-zinc-800 grid place-items-center shrink-0">
        {value ? (
          <img src={value} alt="Profile" className="w-full h-full object-cover" data-testid={`${testid}-preview`} />
        ) : (
          <User className="w-8 h-8 text-zinc-500" />
        )}
      </div>
      <div>
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          disabled={busy}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium border border-zinc-700 text-zinc-200 hover:border-[#E53E3E] hover:text-white transition-colors"
          data-testid={`${testid}-button`}
        >
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Camera className="w-4 h-4" />}
          {value ? "Change photo" : "Upload photo"}
        </button>
        <p className="text-xs text-zinc-500 mt-1">JPG or PNG, auto-resized.</p>
        <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={pick} data-testid={`${testid}-input`} />
      </div>
    </div>
  );
}
